import { render, staticRenderFns } from "./TabVideoCoursedetail.vue?vue&type=template&id=78f88a95&scoped=true"
import script from "../../../services/teacher/VideoCourseTab/tab-videocoursedetail.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/VideoCourseTab/tab-videocoursedetail.js?vue&type=script&lang=js&external"
import style0 from "../../../assets/css/teacher/DetailClassTab/tab-classdetail.css?vue&type=style&index=0&id=78f88a95&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f88a95",
  null
  
)

export default component.exports